import { Injectable } from '@angular/core';
import { ILocalBranch } from '@models/localBranch';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './localBranches.actions';

@Injectable({
	providedIn: 'root',
})
export class LocalBranchDispatch {
	@Dispatch()
	Create = (localBranch: ILocalBranch, mortgageId?: string): actions.Create =>
		new actions.Create(localBranch, mortgageId);

	@Dispatch()
	Remove = (folderId: string): actions.Remove => new actions.Remove(folderId);

	@Dispatch()
	UpdateLocalBranch = (localBranch: ILocalBranch): actions.UpdateLocalBranch =>
		new actions.UpdateLocalBranch(localBranch);
}
